/* eslint-disable no-use-before-define */
import React from "react";
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";
import Chip from "@material-ui/core/Chip";
import Tooltip from "@material-ui/core/Tooltip";
import { withStyles, makeStyles } from "@material-ui/core/styles";
import { Typography } from "@material-ui/core";

const HtmlTooltip = withStyles((theme) => ({
  tooltip: {
    backgroundColor: "#f5f5f9",
    color: "rgba(0, 0, 0, 0.87)",
    maxWidth: 220,
    fontSize: theme.typography.pxToRem(12),
    border: "1px solid #dadde9",
  },
}))(Tooltip);

export default function FreeSolo({
  value,
  onChange,
  placeholder,
  label,
  required,
  options = [],
  onClick,
}) {
  return (
    <Autocomplete
      multiple
      freeSolo
      id="tags-outlined"
      options={options}
      value={value}
      onChange={onChange}
      {...(onClick && {
        renderTags: (value, getTagProps) =>
          value.map((option, index) => (
            <HtmlTooltip
              title={
                <React.Fragment>
                  <Typography color="inherit">{option}</Typography>
                </React.Fragment>
              }
              placement="right-end"
            >
              <Chip
                clickable
                onClick={onClick}
                variant="default"
                label={option}
                {...getTagProps({ index })}
              />
            </HtmlTooltip>
          )),
      })}
      renderInput={(params) => (
        <TextField
          {...params}
          variant="standard"
          label={label}
          placeholder={placeholder}
          required={required}
        />
      )}
    />
  );
}
